<template>
  <pie-chart :data="estatisticas" :donut="true" height="200px" :colors="[ '#53b256','#fe9f43']"></pie-chart>
</template>

<script>
export default {
  data: () => ({}),
  props: ["estatisticas"],
  watch: {
    atualizaGrafico: function() {
      this.estatisticas;
    }
  }
};
</script>

<style>
</style>